import { characters } from '@/mocks/animeData';

export default function CharacterMap() {
  return (
    <section id="characters" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
              <i className="ri-group-line"></i>角色关系
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">角色关系梳理</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              谁在守护谁，谁又欠谁一句道歉？一张图理清《搞鸡小队》的人际网络。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {characters.map((c) => (
            <article
              key={c.id}
              className="group rounded-3xl bg-background-100 p-4 text-center transition-transform hover:-translate-y-1"
            >
              <div className={`relative mx-auto h-24 w-24 overflow-hidden rounded-full md:h-28 md:w-28 ${c.color} p-1`}>
                <img
                  src={c.image}
                  alt={`角色：${c.name}`}
                  className="h-full w-full rounded-full object-cover object-top"
                />
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{c.name}</h3>
              <span className={`mt-1 inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ${c.color} text-background-50`}>
                {c.role}
              </span>
              <p className="mt-3 line-clamp-3 text-xs leading-relaxed text-foreground-600">
                {c.desc}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-3xl bg-primary-500 px-6 py-6 md:flex-row md:px-8">
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/20 text-background-50">
              <i className="ri-heart-line text-xl"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg text-background-50">关系会在每集更新后同步刷新</h3>
              <p className="text-xs text-background-50/85">阿绿反转、板凳爆发等关键节点，都有专题版关系梳理。</p>
            </div>
          </div>
          <a
            href="#episodes"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
          >
            看分集解说 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}